import { Table } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import useMultiNotification from "../../hooks/useNotification";
import { getAllWaitingList } from "../../redux-toolkit/slices/waitingListSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import AppLoader from "../Items/loader/AppLoader";

// ✅ US state codes and names mapping
const US_STATES: Record<string, string> = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

export default function ViewWaitingList() {
  const dispatch = useAppDispatch();
  const { contextHolder } = useMultiNotification();
  const { list, isApiLoading } = useSelector(
    (state: RootState) => state.waitingList
  );

  useEffect(() => {
    dispatch(getAllWaitingList());
  }, [dispatch]);

  if (isApiLoading) {
    return <AppLoader />;
  }

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: (code: string) => {
        const stateName = US_STATES[code.toUpperCase()] || "Unknown";
        return `${code.toUpperCase()} — ${stateName}`;
      },
    },
    {
      title: "Subscribed At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date: string) => new Date(date).toLocaleString(),
    },
  ];

  return (
    <>
      {contextHolder}
      <h1>Waiting List</h1>
      <Table
        dataSource={list}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 10 }}
      />
    </>
  );
}
